import React, {useEffect, useState} from 'react';
import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";

const CheckDayOfWeek = ({
                          propTitle = '수신 요일',
                          propDefaultValue,
                          propOnChange = null
                        }) => {

  useEffect(() => {
    updateChecked();
  }, [propDefaultValue])

  const [stChecked, setChecked] = useState({});

  const updateChecked = () => {
    let mon, tue, wed, thu, fri, sat, sun, temp;
    if (propDefaultValue != null) {
      temp = parseInt(propDefaultValue)
      //console.log(temp);
      mon = (temp / 1000000) >= 1;
      temp %= 1000000;
      tue = (temp / 100000) >= 1;
      temp %= 100000;
      wed = (temp / 10000) >= 1;
      temp %= 10000;
      thu = (temp / 1000) >= 1;
      temp %= 1000;
      fri = (temp / 100) >= 1;
      temp %= 100;
      sat = (temp / 10) >= 1;
      temp %= 10;
      sun = (temp) >= 1;

      setChecked({
        mon: mon,
        tue: tue,
        wed: wed,
        thu: thu,
        fri: fri,
        sat: sat,
        sun: sun
      });
    }
  };


  return (
      <Form.Group as={Row} controlId='dayOfWeek'>
        <Form.Label column md={3} className={'label text-end fw-bold'}>
          <span className={"text-danger"}>* </span>{propTitle}
        </Form.Label>
        <Col md={9}>
          <Row>
            <Col className={'checkbox'}>
              <input type={"checkbox"} name={"mon"} id={"mon"} className={""}
                     onChange={(e) => {
                       // console.log("monmon");
                       propOnChange(e, 0);
                     }}
                     checked={stChecked.mon}
              />
              <label htmlFor={"mon"} className={'label text-end ps-1'}>
                월
              </label>
            </Col>
            <Col className={'checkbox'}>
              <input type={"checkbox"} name={"tue"} id={"tue"} className={""}
                     onChange={(e) => {
                       propOnChange(e, 1);
                     }}
                     checked={stChecked.tue}
              />
              <label htmlFor={"tue"} className={'label text-end ps-1'} name={"tue"}>
                화
              </label>
            </Col>
            <Col className={'checkbox'}>
              <input type={"checkbox"} name={"wed"} id={"wed"} className={""}
                     onChange={(e) => {
                       propOnChange(e, 2);
                     }}
                     checked={stChecked.wed}
              />
              <label htmlFor={"wed"} className={'label text-end ps-1'} name={"wed"}>
                수
              </label>
            </Col>
            <Col className={'checkbox'}>
              <input type={"checkbox"} name={"thu"} id={"thu"} className={""}
                     onChange={(e) => {
                       propOnChange(e, 3);
                     }}
                     checked={stChecked.thu}
              />
              <label htmlFor={"thu"} className={'label text-end ps-1'} name={"thu"}>
                목
              </label>
            </Col>
            <Col className={'checkbox'}>
              <input type={"checkbox"} name={"fri"} id={"fri"} className={""}
                     onChange={(e) => {
                       propOnChange(e, 4);
                     }}
                     checked={stChecked.fri}
              />
              <label htmlFor={"fri"} className={'label text-end ps-1'} name={"fri"}>
                금
              </label>
            </Col>
            <Col className={'checkbox'}>
              <input type={"checkbox"} name={"sat"} id={"sat"} className={""}
                     onChange={(e) => {
                       propOnChange(e, 5);
                     }}
                     checked={stChecked.sat}
              />
              <label htmlFor={"sat"} className={'label text-end ps-1'} name={"sat"}>
                토
              </label>
            </Col>
            <Col className={'checkbox'}>
              <input type={"checkbox"} name={"sun"} id={"sun"} className={""}
                     onChange={(e) => {
                       propOnChange(e, 6);
                     }}
                     checked={stChecked.sun}
              />
              <label htmlFor={"sun"} className={'label text-end ps-1'} name={"sun"}>
                일
              </label>
            </Col>
          </Row>
        </Col>
      </Form.Group>
  );
};

export default CheckDayOfWeek;